import questionTypes from '../questionTypes';
import createEmptyOptionCollection from '../../utils/createEmptyOptionCollection';
import segmentLabelMap from '../../config/segmentLabelMap';
import getCommonBlockProps, { commentsProps } from './getCommonBlockProps';
import {
  DEFAULT_COL_LABEL,
  DEFAULT_MAX_OPTIONS_COUNT,
  DEFAULT_ROW_LABEL,
} from './constants';
import {
  ALIGNMENT_TYPE_BOTTOM,
  ALIGNMENT_TYPE_CENTER,
} from '../../constants/alignmentType';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';

export const defaultSize = { col: 4, row: 2 };

export default {
  type: questionTypes.questionMatrixMulti,
  getDefaultProps: () => ({
    ...getCommonBlockProps(),
    ...commentsProps,
    labelAlignments: {
      vertical: ALIGNMENT_TYPE_BOTTOM,
      horizontal: ALIGNMENT_TYPE_CENTER,
    },
    options: createEmptyOptionCollection(defaultSize.row, DEFAULT_ROW_LABEL),
    [segmentLabelMap.itemList]: createEmptyOptionCollection(
      defaultSize.col,
      DEFAULT_COL_LABEL,
    ),
  }),
  limits: {
    options: {
      max: DEFAULT_MAX_OPTIONS_COUNT,
      min: 1,
    },
    itemList: {
      max: 10, // do not change in one place, need to look up for all 3 types of Matrix and check for '$matrix-max-column-count' variable @sinslav
      min: 3,
    },
  },
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    isRequiredField: () => false,
    isUniqueField: () => false,
    isTextRequired: () => true,
  },
};
